let TimeUnit;

(function (TimeUnit) {
  TimeUnit[TimeUnit["Second"] = 1000] = "Second";
  TimeUnit[TimeUnit["Minute"] = 60000] = "Minute";
  TimeUnit[TimeUnit["Hour"] = 3600000] = "Hour";
  TimeUnit[TimeUnit["Day"] = 86400000] = "Day";
  TimeUnit[TimeUnit["Week"] = 604800000] = "Week";
  TimeUnit[TimeUnit["Year"] = 31536000000] = "Year";
})(TimeUnit || (TimeUnit = {}));

export { TimeUnit };
